import type { ComboboxOption } from "@src/sharedComponents/Combobox/Combobox";
import type { AutocompleteOption } from "@src/sharedComponents/Dropdown/Dropdown";

export const UNKNOWN_USER = "Unknown User";
export const UNKNOWN_GROUP = "Unknown Group";
export const UNKNOWN_VALUE = "-";

export const TASK_CREATION_PROCESS_DOC =
  "https://docs.google.com/document/d/15lMZ76q6D8_qkR1-Y4d6BDzi6k29SKn0Mr1q7C95KXU/edit?tab=t.0";

export type EnhancedAutocompleteOption<
  T extends string | boolean | undefined = string
> = AutocompleteOption & { value: T };

export type EnhancedAutocompleteOptionV2<
  T extends string | boolean | undefined = string
> = AutocompleteOption & { value: T } & Pick<ComboboxOption<string>, "meta">;

export type WithGroupMeta = { meta: { group: string } };
